module.exports = __webpack_public_path__ + "static/media/icon-security.d784e8d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-security.svg
// module id = 2891
// module chunks = 0